export default {
  business: 'Para tu negocio',
  'get-inspired': 'Déjate Inspirar',
  'how-to': 'Cómo Se Hace',
  news: 'Novedades',
  printstories: 'Printstories',
  highlights: 'Highlights',
  'business-growth': 'Business growth',
}
